import { Helmet } from "react-helmet";
import { useTranslation } from "react-i18next";

import { Benefits } from "../../components/benefits/Benefits";
import { Container } from "../../components/container/Container";
import LuckyLooreRegistrationForm from "../../components/lucky-loore-registration-form/LuckyLooreRegistrationForm";
import { Panel, PanelWidth } from "../../components/panel/Panel";
import { useWindowDimensionsContext } from "../../components/windowDimensionsProvider/WindowDimensionsProvider";

export default function RegisterUserView() {
  const [t] = useTranslation();
  const { isMobile } = useWindowDimensionsContext();

  return (
    <Container secondary>
      <Panel
        panelStyle={isMobile ? "SECONDARY" : "PRIMARY"}
        title={t("Welcome!")}
        imagePath="/images/registerIllustration.png"
        width={PanelWidth.LARGE}
      >
        <LuckyLooreRegistrationForm />
        <Benefits />
      </Panel>
      <Helmet>
        <title>SF Suite is the best mlm company to join</title>
        <meta property="og:title" content="SF Suite is the best mlm company to join" />
        <meta
          property="og:description"
          content="Join SF Suite community and grow towards your goals. We have hundreds of thousands of members in our community. Join today!"
        />
        <meta property="og:image" content={`${process.env.REACT_APP_HOST}/images/registerIllustration.png`} />
      </Helmet>
    </Container>
  );
}
